import { ButtonHTMLAttributes } from 'react';
import { classNames } from '../utils/helpers';

type Variant = 'primary' | 'secondary' | 'danger' | 'ghost' | 'navy' | 'success';
type Size    = 'sm' | 'md' | 'lg';

const VARIANTS: Record<Variant, string> = {
  primary:   'bg-violet-700 text-white border-transparent hover:bg-violet-800',
  secondary: 'bg-transparent text-violet-700 border border-violet-700 hover:bg-violet-50',
  danger:    'bg-red-700 text-white border-transparent hover:bg-red-800',
  ghost:     'bg-transparent text-gray-600 border border-gray-200 hover:bg-gray-50',
  navy:      'bg-[#010E23] text-white border-transparent hover:bg-[#0A1F45]',
  success:   'bg-[#1A7A3C] text-white border-transparent hover:bg-green-800',
};

const SIZES: Record<Size, string> = {
  sm: 'text-xs px-3 py-1.5',
  md: 'text-sm px-4 py-2',
  lg: 'text-sm px-6 py-2.5',
};

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
}

export default function Button({
  children, variant = 'primary', size = 'md',
  disabled, className = '', ...rest
}: ButtonProps) {
  return (
    <button
      disabled={disabled}
      className={classNames(
        'inline-flex items-center gap-1.5 rounded-lg font-semibold border transition-all duration-150',
        VARIANTS[variant],
        SIZES[size],
        disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer',
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
}
